import groupBy from 'lodash/groupBy'

import React, { useState } from 'react'
import { useSelector } from 'hooks/use-redux'
import type { PlaylistTag } from 'types/playlist'
import { getPlaylistTags } from '@disco/state-management/selectors/tags'
import type { ColorIndicator } from '@disco/utils/color-indicators'
import ColorIndicatorSelect from 'components/common/color-indicator-select'
import Row from 'components/common/row'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Tag from 'components/ui/tag'
type Props = {
  tag: PlaylistTag
  onClose: () => void
  onSubmit: (color: ColorIndicator | null | undefined) => unknown
}

const PlaylistTagColorIndicatorModal = (props: Props): React.ReactNode => {
  const playlistTags: PlaylistTag[] = useSelector(getPlaylistTags)
  const [selectedColor, setSelectedColor] = useState<
    ColorIndicator | null | undefined
  >(props.tag.color)

  const handleSubmit = () => {
    props.onSubmit(selectedColor)
  }

  return (
    <ModalWindow
      header={<Heading>Add color indicator to</Heading>}
      actions={
        <DialogFooter
          onClose={props.onClose}
          primary={
            <Button
              appearance="primary"
              caption="Add indicator"
              onClick={handleSubmit}
            />
          }
        />
      }
      onClose={props.onClose}
      width="small"
      isOpen
    >
      <Row columnsSize={[12]}>
        <div>
          <Tag tag={props.tag.name} tagColor={selectedColor} />
        </div>
      </Row>
      <Row columnsSize={[12]}>
        <div>
          <ColorIndicatorSelect
            tooltip="Colored indicators appear as colored dots on the playlist in the explorer."
            used={groupBy(
              playlistTags.filter(tag => tag.color),
              'color',
            )}
            value={selectedColor}
            onChange={setSelectedColor}
          />
        </div>
      </Row>
    </ModalWindow>
  )
}

export default PlaylistTagColorIndicatorModal
